import { AxiosRequestConfig } from "axios";
import { MAX_ALLOWED_QUERY_LENGTH } from "constants/AppConstants";
import Uri from "jsuri";
import pako from "pako";

function compressString(str: string) {
  try {
    const compressed = pako.gzip(str);
    return btoa(String.fromCharCode(...Array.from(compressed)));
  } catch (error) {
    console.error(error);
    return str;
  }
}

function processUrlWithGzip(urlObject: Uri): Uri {
  const queryString = urlObject.query();

  const newUri = new Uri(
    urlObject.host()
      ? `${urlObject.protocol()}://${urlObject.host()}${urlObject.path()}`
      : urlObject.path()
  );

  if (urlObject.port()) {
    newUri.setPort(urlObject.port());
  }

  if (queryString) {
    const params = queryString.replace(/^\?/, "").split("&");
    params.forEach(param => {
      const [key, value] = param.split("=").map(decodeURIComponent);

      if (value && value.length > MAX_ALLOWED_QUERY_LENGTH) {
        const compressed = compressString(value);
        const wrappedValue = `GZ:"${compressed}"`;
        newUri.addQueryParam(key, wrappedValue);
      } else {
        newUri.addQueryParam(key, value || "");
      }
    });
  }

  return newUri;
}

function needsCompression(queryString: string | null) {
  if (!queryString) {
    return false;
  }

  const params = queryString.split("&");
  return params.some(param => {
    const [, value] = param.split("=").map(decodeURIComponent);
    return value && value.length > MAX_ALLOWED_QUERY_LENGTH;
  });
}

export function applyGzipMiddleware(config: AxiosRequestConfig) {
  if (!config.url) {
    return config;
  }

  try {
    const urlObject =
      typeof config.url === "string" ? new Uri(config.url) : config.url;

    const queryString = urlObject.query();

    if (needsCompression(queryString)) {
      const processedUrl = processUrlWithGzip(urlObject);
      config.url = processedUrl.toString();
    }

    return config;
  } catch (error) {
    console.error(error);
    return config;
  }
}
